import { useState } from 'react';
import { Input } from '../../../components/Input';
import { useRegisterMutation } from '../api/authApi';
import { ErrorDataMessage } from '../../../api/baseQuery';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components/Button';

export const useRegisterForm = () => {
  const navigate = useNavigate();
  const [register, { isLoading, error }] = useRegisterMutation();
  const [values, setValues] = useState({
    email: '',
    password: '',
    firstName: '',
    lastName: ''
  });

  const errorData = error?.data as ErrorDataMessage;

  const onRegister = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!values.email || !values.password || !values.firstName || !values.lastName) {
      toast('Please fill all the fields', {
        type: 'error'
      });
      return;
    }

    try {
      await register({ ...values }).unwrap();
      navigate('/login');
      toast('Registered successfully, please check your inbox to validate your e-mail', {
        type: 'success',
        autoClose: 10000
      });
    } catch (err) {
      return err;
    }
  };

  const RegisterForm = (
    <form className="flex flex-col gap-4 w-full" onSubmit={onRegister}>
      <div className="flex gap-3">
        <Input
          label="First Name"
          value={values.firstName}
          placeholder="John"
          name="firstName"
          onChange={(e) => {
            setValues((prev) => ({ ...prev, firstName: e.target.value }));
          }}
          error={errorData?.first_name?.[0]}
          required
        />
        <Input
          label="Last Name"
          value={values.lastName}
          placeholder="Doe"
          name="lastName"
          onChange={(e) => {
            setValues((prev) => ({ ...prev, lastName: e.target.value }));
          }}
          error={errorData?.last_name?.[0]}
          required
        />
      </div>
      <Input
        label="Email"
        type="email"
        value={values.email}
        placeholder="email@example.com"
        name="email"
        onChange={(e) => {
          setValues((prev) => ({ ...prev, email: e.target.value }));
        }}
        error={errorData?.email?.[0]}
        required
      />
      <Input
        label="Password"
        value={values.password}
        placeholder="password"
        name="password"
        onChange={(e) => {
          setValues((prev) => ({ ...prev, password: e.target.value }));
        }}
        error={errorData?.password1?.[0]}
        required
        type="password"
      />
      <Button type="submit" isLoading={isLoading}>
        Register
      </Button>
    </form>
  );
  return { RegisterForm };
};
